import React from "react";
import { getContentImageUrls } from "../../lib/contentImages";
import { FormattedBody } from "../ui/formatted-body";
import { cn } from "../../lib/utils";

/**
 * Square image-first preview tile for a profile posts grid.
 * @param {Object} props
 * @param {object} props.post
 * @param {function} props.onSelect
 * @returns {JSX.Element}
 */
function PostPreviewCard({ post, onSelect }) {
  const imageUrl = getContentImageUrls(post)[0] || "";
  const caption = String(post?.caption || "").trim();
  const label = caption
    ? `Open post: ${caption.slice(0, 80)}`
    : "Open post";

  const openPost = (event) => {
    if (event.target.closest("a")) return;
    onSelect(post.id);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={openPost}
      onKeyDown={(event) => {
        if (event.target.closest("a")) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect(post.id);
        }
      }}
      aria-label={label}
      className={cn(
        "group relative aspect-square w-full overflow-hidden rounded-md border border-ui-border bg-ui-muted text-left",
        "cursor-pointer outline-none transition-transform hover:scale-[1.02]",
        "focus-visible:ring-2 focus-visible:ring-ui-ring"
      )}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center px-3 py-3">
          <FormattedBody
            className="line-clamp-6 text-center text-sm text-text-secondary"
            mentions={post.mentions}
          >
            {caption || "Post"}
          </FormattedBody>
        </div>
      )}
      <span
        className="pointer-events-none absolute inset-0 bg-ui-overlay opacity-0 transition-opacity group-hover:opacity-40 group-focus-visible:opacity-40"
        aria-hidden
      />
    </div>
  );
}

export default PostPreviewCard;
